// src/index.js
import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import "./Styles/styles.scss"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { Provider } from "react-redux"
import { store } from "./Redux/Store/Store"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
)
reportWebVitals()
